import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Tooltip
} from '@mui/material';
import {
  TrendingUp,
  TrendingDown,
  Remove
} from '@mui/icons-material';

const MetricCard = ({ 
  title, 
  value, 
  subtitle, 
  icon: Icon, 
  color = 'primary',
  trend,
  format = 'number',
  loading = false
}) => {
  const formatValue = (val) => {
    if (loading) return '...';
    if (val === null || val === undefined) return '-';
    
    switch (format) {
      case 'currency':
        return new Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: 'ARS',
          minimumFractionDigits: 2
        }).format(val);
      case 'percentage':
        return `${val.toFixed(2)}%`;
      case 'number':
      default:
        return new Intl.NumberFormat('es-AR').format(val);
    }
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    
    if (trend > 0) {
      return <TrendingUp sx={{ fontSize: 16, color: 'success.main' }} />;
    } else if (trend < 0) {
      return <TrendingDown sx={{ fontSize: 16, color: 'error.main' }} />;
    }
    return <Remove sx={{ fontSize: 16, color: 'text.secondary' }} />;
  };

  const getTrendColor = () => {
    if (!trend) return 'text.secondary';
    return trend > 0 ? 'success.main' : trend < 0 ? 'error.main' : 'text.secondary';
  };

  return (
    <Card 
      elevation={0}
      sx={{ 
        height: '100%',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        transition: 'all 0.3s ease',
        '&:hover': {
          borderColor: `${color}.main`,
          boxShadow: 2,
          transform: 'translateY(-2px)'
        }
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{ fontWeight: 500, textTransform: 'uppercase', fontSize: '0.75rem' }}
          >
            {title}
          </Typography>
          {Icon && (
            <Box
              sx={{
                bgcolor: `${color}.main`,
                color: 'white',
                borderRadius: 2,
                p: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: 0.9
              }}
            >
              <Icon sx={{ fontSize: 20 }} />
            </Box>
          )}
        </Box>
        
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 700,
            mb: 1,
            color: 'text.primary',
            wordBreak: 'break-word'
          }}
        >
          {formatValue(value)}
        </Typography>
        
        {subtitle && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {getTrendIcon()}
            <Typography 
              variant="body2" 
              sx={{ 
                color: getTrendColor(),
                fontWeight: 500
              }}
            >
              {subtitle}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default MetricCard;
